import Cookies from 'js-cookie'
import { setLoginBadge, removeLoginBadge } from '@/utils/examineNotice'

const TokenKey = 'QStar-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  setLoginBadge()
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  removeLoginBadge()
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js